import { NormalizedProductUsageDataBreakdown } from './product-usage-breakdown-normalizer/normalized-product-usage-data-breakdown';

export function buildDateProductUsageChartDataItem(
  usageByDate: NormalizedProductUsageDataBreakdown,
): Record<string, number> {
  return usageByDate.customerUsage.reduce<Record<string, number>>((dataItem, customerUsage) => {
    dataItem[customerUsage.customerId] = customerUsage.units;

    return dataItem;
  }, {});
}
